/** 协同端展示采购、委外相关打印模板 */
export default {
  tablew: [],
  treeList: [
    {
      id: 3,
      label: '采购模块',
      modules: 0,
      children: [
        { id: 15, modules: 15, label: '采购订单', children: [] }, // 与 userLogin 采购订单 modules 一致，不是协同菜单号 31
        { id: 32, modules: 32, label: '采购发货', children: [] }
      ]
    },
    {
      id: 7,
      label: '委外模块',
      modules: 0,
      children: [
        { id: 47, modules: 47, label: '产品委外订单', children: [] },
        { id: 48, modules: 48, label: '产品委外发料', children: [] },
        { id: 49, modules: 49, label: '产品委外退料', children: [] },
        { id: 50, modules: 50, label: '产品委外出货', children: [] },
        { id: 127, modules: 127, label: '工序委外订单', children: [] },
        { id: 170, modules: 170, label: '工序委外发料', children: [] },
        { id: 171, modules: 171, label: '工序委外退料', children: [] },
        { id: 172, modules: 172, label: '工序委外发货', children: [] },
        { id: 84, modules: 84, label: '委外对账单', children: [] },
        { id: 195, modules: 195, label: '协同库存详情', children: [] }
      ]
    }
  ]
};
